/**
 * 所有子路由模块命名规则约定
 * 1、必须以父模块name为开头，且用'-'隔开
 * 2、path必须是双层，且开头为夫模块 如：/a/b  a为父模块
 */

/**
 * @params { meta }
 * @module:  标识独立模块，用于初始化设置视野
 */
// var statisTable = sessionStorage.getItem("statisTable")
// if (statisTable) {
//     statisTable = JSON.parse(statisTable)
//     if (statisTable.length) {
//         var statisRedirect = '/statis/' + statisTable[0].substring(7, statisTable[0].length)
//     }
// }
// console.log(statisRedirect)
export default [{
  path: '',
  component: function component() {
    if (window.GLOBAL_CONFIG.showTopBar === false) return import('@/views/components/menu/topbar-none.vue');
    return import('@/views/components/menu/topbar.vue');
  },
  children: [{
    path: '/typhoonAnalysis*',
    name: 'typhoonAnalysis',
    meta: {
      isMicroApp: true
    }
  }, {
    path: '',
    component: function component() {
      return import('@/components/map');
    },
    children: [{
      path: '/tfjc',
      name: 'tfjc',
      component: function component() {
        return import('@/views/monitor-typhoon');
      }
    }, {
      path: '/ldcy',
      name: 'ldcy',
      component: function component() {
        return import('@/views/monitor-radar');
      }
    }, {
      path: '/history',
      name: 'history',
      component: function component() {
        return import('@/views/typhoon-history');
      }
    }, {
      path: '/rainfall',
      name: 'rainfall',
      meta: {
        module: true // 标识独立模块，用于初始化设置视野

      },
      component: function component() {
        return import('@/views/monitor-rainfall');
      }
    }, {
      path: '/rainfallRR',
      name: 'rainfallRR',
      meta: {
        module: true // 标识独立模块，用于初始化设置视野

      },
      component: function component() {
        return import('@/views/monitor-rainfall-RR');
      } // 水库雨情

    }, {
      path: '/water',
      name: 'water',
      meta: {
        module: true // 标识独立模块，用于初始化设置视野

      },
      component: function component() {
        return import('@/views/monitor-water');
      }
    }, {
      path: '/project',
      name: 'project',
      meta: {
        module: true // 标识独立模块，用于初始化设置视野

      },
      component: function component() {
        return import('@/views/monitor-project');
      }
    }, // 山洪风险
    {
      path: '/floodrisk',
      name: 'floodrisk',
      meta: {
        module: true // 标识独立模块，用于初始化设置视野

      },
      component: function component() {
        return import('@/views/module-floodrisk');
      }
    }, {
      path: '/waterRR',
      name: 'waterRR',
      meta: {
        module: true // 标识独立模块，用于初始化设置视野

      },
      component: function component() {
        return import('@/views/monitor-water-RR');
      } // 水库水情

    }, {
      path: '/facility',
      name: 'facility',
      component: function component() {
        return import('@/views/monitor-facility');
      }
    }, {
      path: '/disaster',
      name: 'disaster',
      component: function component() {
        return import('@/views/module-disaster');
      }
    }, {
      path: '/rain',
      name: 'rain',
      component: function component() {
        return import('@/views/components/module-rainfall-future');
      }
    }, {
      path: '/szyb',
      name: 'szyb',
      component: function component() {
        return import('@/views/module-szyb');
      }
    }, {
      path: '/fire',
      name: 'fire',
      component: function component() {
        return import('@/views/module-fire');
      }
    }, {
      path: '/earthquake',
      name: 'earthquake',
      component: function component() {
        return import('@/views/module-earthquake');
      }
    }, {
      path: '/realscence',
      name: 'realscence',
      component: function component() {
        return import('@/views/module-realscence');
      }
    }, {
      path: '/ships',
      name: 'ships',
      component: function component() {
        return import('@/views/module-ships');
      }
    }, {
      path: '/maritimerescue',
      name: 'maritimerescue',
      component: function component() {
        return import('@/views/module-maritime-rescue');
      }
    }, {
      path: '/nearbyocean',
      name: 'nearbyocean',
      component: function component() {
        return import('@/views/module-nearby-ocean');
      }
    }, {
      path: '/nearbycoastal',
      name: 'nearbycoastal',
      component: function component() {
        return import('@/views/module-nearby-coastal');
      }
    }, {
      path: '/oceanmonitor',
      name: 'oceanmonitor',
      component: function component() {
        return import('@/views/module-ocean-monitor');
      }
    }, {
      path: '/windlive',
      name: 'windLive',
      meta: {
        module: true // 标识独立模块，用于初始化设置视野

      },
      component: function component() {
        return import('@/views/module-disaster/components/wind-live');
      }
    }, {
      path: '/rainfallforecast',
      name: 'rainfallforecast',
      component: function component() {
        return import('@/views/module-rainfall-forecast');
      }
    }, {
      path: '/reservoirrisk',
      name: 'reservoirrisk',
      component: function component() {
        return import('@/views/module-reservoir-risk');
      }
    }, {
      path: '/ponding',
      name: 'ponding',
      meta: {
        module: true // 标识独立模块，用于初始化设置视野

      },
      component: function component() {
        return import('@/views/monitor-ponding');
      }
    }]
  }, {
    path: '/helper',
    name: 'helper',
    component: function component() {
      return import('@/views/module-helper/helper');
    }
  }, {
    path: '/notification',
    name: 'notification',
    permanent: true,
    component: function component() {
      return import('@/views/module-notification');
    }
  }, {
    path: '/membernotification',
    name: 'membernotification',
    permanent: true,
    component: function component() {
      return import('@/views/module-member-notification');
    }
  }, {
    path: '/professionor',
    name: 'professionor',
    component: function component() {
      return import('@/views/module-professionor');
    }
  }, // {
  //     path: '/realscence',
  //     name: 'realscence',
  //     component: () => import('@/views/module-realscence')
  // },
  {
    path: '/statis',
    name: 'statis',
    component: function component() {
      return import('@/views/monitor-statis/layout');
    },
    // redirect: statisRedirect,
    children: [{
      path: 'rain-day',
      meta: {
        title: '日雨量统计表'
      },
      name: 'statis-rain-day',
      component: function component() {
        return import('@/views/monitor-statis/pages/rain-day');
      }
    }, {
      path: 'rain-month',
      meta: {
        title: '月雨量统计表'
      },
      name: 'statis-rain-month',
      component: function component() {
        return import('@/views/monitor-statis/pages/rain-month');
      }
    }, {
      path: 'rain-slot',
      meta: {
        title: '时段雨量统计表'
      },
      name: 'statis-rain-slot',
      component: function component() {
        return import('@/views/monitor-statis/pages/rain-slot');
      }
    }, // 水库水情表
    {
      path: 'water-reservoir',
      meta: {
        title: '水库水情表'
      },
      name: 'statis-water-reservoir',
      component: function component() {
        return import('@/views/monitor-statis/pages/water-reservoir');
      }
    }, // 河道水情表
    {
      path: 'water-river',
      meta: {
        title: '河道水情表'
      },
      name: 'statis-water-river',
      component: function component() {
        return import('@/views/monitor-statis/pages/water-river');
      }
    }]
  }, {
    path: '/yjpt',
    name: 'yjpt',
    component: function component() {
      return import('@/views/module-disaster-warning');
    },
    redirect: '/yjpt/manage',
    children: [{
      path: 'manage',
      name: 'yjpt-manage',
      meta: {
        title: '预警规则管理'
      },
      component: function component() {
        return import('@/views/module-disaster-warning/pages/manage');
      }
    }, {
      path: 'create',
      name: 'yjpt-create',
      meta: {
        title: '预警规则创建',
        keepLive: true
      },
      component: function component() {
        return import('@/views/module-disaster-warning/pages/create');
      }
    }, {
      path: 'yjhistory',
      name: 'yjpt-yjhistory',
      meta: {
        title: '预警历史消息'
      },
      component: function component() {
        return import('@/views/module-disaster-warning/pages/history');
      }
    }]
  }, {
    path: '/meteorology',
    name: 'meteorology',
    component: function component() {
      return import('@/views/module-meteorology');
    }
  }, {
    path: '/maritimerescue/rescueforecast',
    name: 'maritimerescue-rescueforecast',
    component: function component() {
      return import('@/views/module-maritime-rescue/pages-forecast');
    }
  }, // 实时视频
  {
    path: '/realtimevideo',
    name: 'realtimevideo',
    component: function component() {
      return import('@/views/module-realtimevideo');
    }
  }, {
    path: '/monitorvideo',
    name: 'monitorvideo',
    component: function component() {
      return import('@/views/monitor-video');
    }
  }, {
    path: '/pondingwarning',
    name: 'pondingwarning',
    component: function component() {
      return import('@/views/monitor-ponding-warning');
    }
  }]
}, {
  path: '/home',
  name: 'home',
  component: function component() {
    return import('@/views/module-comprehensive-home');
  }
}, {
  path: '/risks',
  name: 'risks',
  component: function component() {
    return import('@/views/module-risks');
  }
}, {
  path: '/risksguarantee',
  name: 'risksguarantee',
  component: function component() {
    return import('@/views/module-risk-guarantee');
  }
}, {
  path: '/waterlogging',
  name: 'waterlogging',
  component: function component() {
    return import('@/views/module-waterlogging');
  }
} // {
//     path: '/home',
//     name: 'home',
//     component: () => import('@/views/module-home')
// }
];